import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_GPS_GAMMING_POSITIONS = "REQUEST_MAP_GPS_GAMMING_POSITIONS";
const RESPONSE_MAP_GPS_GAMMING_POSITIONS = "RESPONSE_MAP_GPS_GAMMING_POSITIONS";
const REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE = "REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE";
const CLEAR_MAP_GPS_GAMMING_POSITIONS = "CLEAR_MAP_GPS_GAMMING_POSITIONS";

const requestMapGpsJammingPositionsAction = () => {
  return {
    type: REQUEST_MAP_GPS_GAMMING_POSITIONS,
  };
};

const responseMapGpsJammingPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_GPS_GAMMING_POSITIONS,
    payload: data,
  };
};

const requestMapGpsJammingPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE,
    errors,
  };
};

const getMapGpsJammingPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapGpsJammingPositionsAction());

    intellegenceService
      .getGpsJammings(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMapGpsJammingPositionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMapGpsJammingPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapGpsJammingPositionsAction = () => {
  return {
    type: CLEAR_MAP_GPS_GAMMING_POSITIONS,
  };
};

export {
  REQUEST_MAP_GPS_GAMMING_POSITIONS,
  RESPONSE_MAP_GPS_GAMMING_POSITIONS,
  REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE,
  CLEAR_MAP_GPS_GAMMING_POSITIONS,
  getMapGpsJammingPositions,
  clearMapGpsJammingPositionsAction,
};
